module.exports = __webpack_public_path__ + "assets/img/tiktok.33befd40.png";